import { render, staticRenderFns } from "./PortalMeusDados.vue?vue&type=template&id=dbc6fd42&"
import script from "./PortalMeusDados.vue?vue&type=script&lang=js&"
export * from "./PortalMeusDados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports